import {Component, Injector, OnInit} from '@angular/core';
import {Meta, Title} from '@angular/platform-browser';
import {BaseComponents} from '../../shared/base-components';
import {TYPE_META} from '../../core/constants/meta_title.constant';

@Component({
    selector: 'app-perguntas-frequentes',
    templateUrl: './perguntas-frequentes.component.html',
    styleUrls: ['./perguntas-frequentes.component.sass']
})
export class PerguntasFrequentesComponent extends BaseComponents implements OnInit {

    constructor(protected injector: Injector,
                protected titleService: Title,
                protected meta: Meta) {
        super(injector);
    }

    ngOnInit() {
        this.setMetaTitle(TYPE_META.PERGUNTAS_FREQUENTES);
    }
}
